import {MOON_800} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const Name = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
`;

export const Description = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: ${MOON_800};
`;
